import { getSelectedProduct, selectProduct } from 'axp-product-ducks';
import { getProcedureResult } from 'iguazu-rpc';

import { READ_CUSTOMER_PRODUCTS_V2_FUNCTION } from '../constants';
import {
  isDepositsManageProfileUrl,
  isDepositsUrl,
} from './businessBankingRouteUtil';
import getAccountNumberFromPath from './getAccountNumberFromPath';
import getBaseRoute from './getBaseRoute';
import { getProduct, getProductRouteContext } from './productUtil';

const onEnterSetSelectedProduct =
  (store) => async (nextState, replace, callback) => {
    const productsResult = getProcedureResult({
      procedureName: READ_CUSTOMER_PRODUCTS_V2_FUNCTION,
      args: {
        timeout: 6e3,
      },
    })(store.getState());

    const currentPath = nextState.location?.pathname;

    // product in this context is account token
    const currentProduct = await getSelectedProduct(store.getState());
    const newSelectedProduct = getAccountNumberFromPath(
      currentPath,
      nextState.params?.accountIdentifier
    );

    // Use newSelectedProduct to figure out the matched account, fallback default, and validity checks.
    const {
      newSelectedProductObj,
      defaultProduct,
      isAccountTokenOrPathValid,
      productTypeFromPath,
    } = getProductRouteContext(productsResult, currentPath, newSelectedProduct);

    const currentProductObj = getProduct(productsResult, currentProduct);

    const isDepositsPath = isDepositsUrl(currentPath);

    let productToSelect;

    /**
     * Selection flow / priority:
     * 1) Token in URL: choose token account when token+path are valid.
     * 2) Token in URL but invalid: fall back to `defaultProduct`.
     * 3) No token in URL: keep current selected product only when it still matches
     *    route product type and path validity
     */

    if (newSelectedProduct && isAccountTokenOrPathValid) {
      productToSelect = newSelectedProductObj;
    } else if (
      // no token, invalid token/path, or current product not valid for route.
      !currentProductObj ||
      currentProductObj?.type !== productTypeFromPath ||
      isDepositsPath ||
      !isAccountTokenOrPathValid
    ) {
      productToSelect = defaultProduct;
    } else {
      // Keep the current selection when it is still valid for this route.
      productToSelect = currentProductObj;
    }

    if (!productToSelect?.opaqueAccountId) {
      return callback();
    }

    const selectedProductType = productToSelect?.type;

    const route = getBaseRoute(selectedProductType);

    await store.dispatch(selectProduct(productToSelect?.opaqueAccountId));

    if (isDepositsManageProfileUrl(currentPath)) {
      replace(route.MANAGE_PROFILE);
    } else if (!isAccountTokenOrPathValid) {
      const targetPath = route.ACCOUNTS_DETAILS.replace(
        ':id',
        encodeURIComponent(productToSelect?.opaqueAccountId)
      );

      replace(targetPath);
    }

    return callback();
  };

export default onEnterSetSelectedProduct;
